import React from 'react';
import ReactDOM from 'react-dom';
import { MoralisProvider } from 'react-moralis';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import { initializeAnalytics } from './utils/analytics';
import { getLoggedInLDUser } from 'hooks/useFlags';

initializeAnalytics();

// This configures a Service Worker with the given request handlers.
if (process.env.REACT_APP_MOCK_HTTP === 'true') {
  const { worker } = require('./mocks/browser');
  worker.start({
    // we don't want to generate warnings for requests
    // that don't have a matching handler
    onUnhandledRequest: 'bypass',
  });
}

const launchDarklyClientId = process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID;
const moralisApplicationId = process.env.REACT_APP_MORALIS_APPLICATION_ID;
const moralisDappUrl = process.env.REACT_APP_MORALIS_DAPP_URL;

if (!launchDarklyClientId) {
  throw new Error('Launch darkly client-side id not configured');
}

if (!moralisApplicationId) {
  throw new Error('Moralis application id not configured');
}

if (!moralisDappUrl) {
  throw new Error('Moralis dapp url not configured');
}

const renderApp = async () => {
  const LaunchDarklyProvider = await asyncWithLDProvider({
    clientSideID: launchDarklyClientId,
    user: getLoggedInLDUser(),
    options: {
      streaming: true,
    },
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  });

  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <MoralisProvider appId={moralisApplicationId} serverUrl={moralisDappUrl}>
          <LaunchDarklyProvider>
            <App />
          </LaunchDarklyProvider>
        </MoralisProvider>
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
